
export const financialSummaryLabel = {
  government_allocation_product_categories_distributed: 'Distribuição de serviços de empenho',
  government_allocation_products_distributed: 'Distribuição de produtos de empenho',
  granted_credit_product_categories_distributed: 'Cota de Empenho da filial em serviços',
  granted_credit_products_distributed: 'Cota de Empenho da filial em produtos',
}

export const financialSummaryLabelPrivate = {
  government_allocation_product_categories_distributed: 'Distribuição de serviços de empenho',
  government_allocation_products_distributed: 'Distribuição de produtos de empenho',
  granted_credit_product_categories_distributed: 'Limite de crédito em serviços',
  granted_credit_products_distributed: 'Limite de crédito em produtos',
}
